import React from 'react';
import { Link } from 'react-router-dom';

const Services: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold">Our Services</h1>
        <p className="lead">
          At Sterling Tax Solutions, we offer comprehensive tax services to meet the unique needs
          of individuals and businesses.
        </p>
      </div>

      {/* Pricing Table */}
      <div className="row mb-5">
        <div className="col-lg-10 mx-auto">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4">
              <h2 className="text-center mb-4">Service Pricing</h2>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Service</th>
                      <th scope="col" className="text-end">Starting Price*</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Personal Tax Filing</td>
                      <td className="text-end">$20/person</td>
                    </tr>
                    <tr>
                      <td>Corporate Tax Filing</td>
                      <td className="text-end">$850</td>
                    </tr>
                    <tr>
                      <td>GST/HST Registration</td>
                      <td className="text-end">$100</td>
                    </tr>
                    <tr>
                      <td>GST/HST Filing</td>
                      <td className="text-end">$250</td>
                    </tr>
                    <tr>
                      <td>Strategic Tax Planning</td>
                      <td className="text-end">$50/hour</td>
                    </tr>
                    <tr>
                      <td>CRA Audit Defence</td>
                      <td className="text-end">$50/hour</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-muted text-center mt-3 mb-0">
                * Prices may vary based on complexity and specific requirements. Contact us for a detailed quote.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Personal Tax Filing */}
      <div className="row mb-5 align-items-center" id="personal-tax">
        <div className="col-lg-7 order-lg-2">
          <h2 className="mb-3">Personal Tax Filing</h2>
          <div className="mb-3">
            <div className="d-inline-block px-3 py-1 rounded-pill" style={{ backgroundColor: '#0D4D26', color: 'white', fontSize: '0.9rem' }}>
              Starting at $20/person
            </div>
          </div>
          <p>
            Our expert tax professionals handle your personal income tax preparation and filing with
            precision and care, ensuring you receive all eligible deductions and credits.
          </p>
          <h5>What we offer:</h5>
          <ul>
            <li>Comprehensive personal income tax return preparation</li>
            <li>Maximization of eligible deductions and tax credits</li>
            <li>Electronic filing with CRA</li>
            <li>Review of previous years' returns to identify potential refund opportunities</li>
            <li>Year-round support and guidance</li>
            <li>Tax planning advice to minimize future tax liabilities</li>
          </ul>
          <div className="mt-3">
            <Link to="/appointments" className="btn btn-primary me-2">Book an Appointment</Link>
            <Link to="/contact" className="btn btn-outline-primary">Contact Us</Link>
          </div>
        </div>
        <div className="col-lg-5 order-lg-1 text-center mb-4 mb-lg-0">
          <div className="p-4 bg-light rounded-circle d-inline-block">
            <i className="bi bi-file-earmark-text" style={{ fontSize: '5rem', color: '#0D4D26' }}></i>
          </div>
        </div>
      </div>

      <hr className="my-5" />

      {/* GST/HST Registration and Filing */}
      <div className="row mb-5 align-items-center" id="gst-hst">
        <div className="col-lg-7">
          <h2 className="mb-3">GST/HST Registration and Filing</h2>
          <div className="mb-3">
            <div className="d-inline-block px-3 py-1 rounded-pill me-2" style={{ backgroundColor: '#0D4D26', color: 'white', fontSize: '0.9rem' }}>
              Registration: $100
            </div>
            <div className="d-inline-block px-3 py-1 rounded-pill" style={{ backgroundColor: '#0D4D26', color: 'white', fontSize: '0.9rem' }}>
              Filing: $250
            </div>
          </div>
          <p>
            We provide comprehensive GST/HST registration, filing, and compliance services for businesses of all sizes.
          </p>
          <h5>What we offer:</h5>
          <ul>
            <li>GST/HST registration assistance for new businesses</li>
            <li>Preparation and filing of GST/HST returns</li>
            <li>Strategic advice on input tax credits</li>
            <li>Compliance reviews to ensure you're meeting all GST/HST obligations</li>
            <li>Guidance on GST/HST implications for various business transactions</li>
            <li>Assistance with GST/HST audits</li>
          </ul>
          <div className="mt-3">
            <Link to="/appointments" className="btn btn-primary me-2">Book an Appointment</Link>
            <Link to="/contact" className="btn btn-outline-primary">Contact Us</Link>
          </div>
        </div>
        <div className="col-lg-5 text-center mb-4 mb-lg-0">
          <div className="p-4 bg-light rounded-circle d-inline-block">
            <i className="bi bi-buildings" style={{ fontSize: '5rem', color: '#0D4D26' }}></i>
          </div>
        </div>
      </div>

      <hr className="my-5" />

      {/* CRA Audit Defence */}
      <div className="row mb-5 align-items-center" id="audit-defence">
        <div className="col-lg-7 order-lg-2">
          <h2 className="mb-3">CRA Audit Defence</h2>
          <div className="mb-3">
            <div className="d-inline-block px-3 py-1 rounded-pill" style={{ backgroundColor: '#0D4D26', color: 'white', fontSize: '0.9rem' }}>
              $50/hour
            </div>
          </div>
          <p>
            If you're facing a CRA audit, our team provides expert representation and support to
            protect your interests and navigate the process with confidence.
          </p>
          <h5>What we offer:</h5>
          <ul>
            <li>Professional representation during CRA audits</li>
            <li>Preparation and organization of required documentation</li>
            <li>Communication with CRA auditors on your behalf</li>
            <li>Strategic advice to minimize adjustments and penalties</li>
            <li>Assistance with responding to CRA notices and queries</li>
            <li>Support for objections and appeals if needed</li>
          </ul>
          <div className="mt-3">
            <Link to="/appointments" className="btn btn-primary me-2">Book an Appointment</Link>
            <Link to="/contact" className="btn btn-outline-primary">Contact Us</Link>
          </div>
        </div>
        <div className="col-lg-5 order-lg-1 text-center mb-4 mb-lg-0">
          <div className="p-4 bg-light rounded-circle d-inline-block">
            <i className="bi bi-shield-check" style={{ fontSize: '5rem', color: '#0D4D26' }}></i>
          </div>
        </div>
      </div>

      <hr className="my-5" />

      {/* Tax Planning */}
      <div className="row mb-5 align-items-center" id="tax-planning">
        <div className="col-lg-7">
          <h2 className="mb-3">Tax Planning</h2>
          <div className="mb-3">
            <div className="d-inline-block px-3 py-1 rounded-pill" style={{ backgroundColor: '#0D4D26', color: 'white', fontSize: '0.9rem' }}>
              $50/hour
            </div>
          </div>
          <p>
            Our tax planning services help you minimize tax liabilities while achieving your
            financial goals through strategic advice and forward-looking tax strategies.
          </p>
          <h5>What we offer:</h5>
          <ul>
            <li>Personalized tax planning strategies</li>
            <li>Year-round tax advice and consultation</li>
            <li>RRSP, TFSA, and RESP optimization</li>
            <li>Income splitting techniques for families</li>
            <li>Retirement tax planning</li>
            <li>Business tax planning for entrepreneurs and professionals</li>
            <li>Investment tax planning strategies</li>
          </ul>
          <div className="mt-3">
            <Link to="/appointments" className="btn btn-primary me-2">Book an Appointment</Link>
            <Link to="/contact" className="btn btn-outline-primary">Contact Us</Link>
          </div>
        </div>
        <div className="col-lg-5 text-center mb-4 mb-lg-0">
          <div className="p-4 bg-light rounded-circle d-inline-block">
            <i className="bi bi-graph-up-arrow" style={{ fontSize: '5rem', color: '#0D4D26' }}></i>
          </div>
        </div>
      </div>

      <hr className="my-5" />

      {/* CPA Designation Mentorship */}
      <div className="row mb-5 align-items-center" id="cpa-mentorship">
        <div className="col-lg-7 order-lg-2">
          <h2 className="mb-3">CPA Designation Mentorship</h2>
          <p>
            We provide professional mentorship and guidance for aspiring Chartered Professional Accountants
            to help them navigate the certification process and build successful careers.
          </p>
          <h5>What we offer:</h5>
          <ul>
            <li>One-on-one mentorship sessions with experienced CPAs</li>
            <li>Guidance on CPA program requirements and examinations</li>
            <li>Career advice and development planning</li>
            <li>Resume and job interview preparation</li>
            <li>Professional skill development coaching</li>
            <li>Industry insights and networking opportunities</li>
          </ul>
          <div className="mt-3">
            <Link to="/appointments" className="btn btn-primary me-2">Book an Appointment</Link>
            <Link to="/contact" className="btn btn-outline-primary">Contact Us</Link>
          </div>
        </div>
        <div className="col-lg-5 order-lg-1 text-center mb-4 mb-lg-0">
          <div className="p-4 bg-light rounded-circle d-inline-block">
            <i className="bi bi-mortarboard" style={{ fontSize: '5rem', color: '#0D4D26' }}></i>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="card sterling-bg mt-5">
        <div className="card-body p-5 text-center text-white">
          <h2 className="card-title mb-3">Ready to get started?</h2>
          <p className="card-text mb-4">
            Contact us today to schedule a consultation and learn how our services can benefit you.
          </p>
          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
            <Link to="/appointments" className="btn btn-light btn-lg">Book an Appointment</Link>
            <Link to="/contact" className="btn btn-outline-light btn-lg">Contact Us</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services; 